import styled from "styled-components";

export const SignUpWrapper = styled.div`
  width: 100%;
  height: 100vh;
  background: #1d1c1c;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 2rem 0;

  @media (max-width: 500px) {
    background: #000;
    height: auto;
    min-height: 100vh;
    min-height: 100svh;
    align-items: flex-start;
    padding: clamp(1.25rem, 5vh, 2rem) 1.25rem calc(2rem + env(safe-area-inset-bottom));
  }
`;

export const SignUpContainer = styled.div`
  width: 600px;
  max-width: 95%;
  // height: 85vh;
  border-radius: 0.7rem;
  margin: auto;
  background-color: #000;
  padding: 2rem 0;

  @media (max-width: 500px) {
    width: min(100%, 420px);
    max-width: 100%;
    margin: 0 auto;
    padding: 0;
  }
`;

export const ColoredLogo = styled.img`
  width: 150px;
  max-width: 90%;
  margin: auto;
  display: block;
  margin-top: 2rem;

  @media (max-width: 500px) {
    width: 116px;
    margin: 0 auto 1.75rem;
  }
`;

export const SignUpContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;
  margin: 3rem auto;
  h1 {
    color: white;
    font-size: 1.8rem;
    font-weight: 100;
  }

  @media (max-width: 500px) {
    width: 100%;
    margin: 0 auto;

    h1 {
      margin: 0;
      font-size: 1.85rem;
      line-height: 1.15;
      text-align: center;
    }
  }

  .login-form {
    width: 100%;
    margin-top: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;

    @media (max-width: 500px) {
      margin-top: 1.5rem;
      gap: 1.25rem;

      input {
        height: 44px;
      }

      button {
        min-height: 46px;
      }

      > p {
        font-size: 0.82rem;
        line-height: 1.5;
      }

      .mt-5 {
        margin-top: 0.85rem;
      }
    }
  }

  .or-title {
    color: #4d4d4d;
    position: relative;
    text-align: center;
    span {
      background-color: #000000;
      position: relative;
      padding: 0 1rem;
      font-family: "Noto Sans", sans-serif;
    }
    &:before {
      content: "";
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 1px;
      background: #4d4d4d;
    }
  }
`;
